(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const announcementBar = document.querySelector('.announcement-bar');
  const mobileViewport = window.matchMedia('(width <= 1000px)');

  const updateAnnouncementBarHeight = () => {
    if (!announcementBar || !mobileViewport.matches || getComputedStyle(announcementBar).display === 'none') {
      document.documentElement.style.removeProperty('--announcement-bar-sticky-height');
      return;
    }

    const height = Math.ceil(announcementBar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--announcement-bar-sticky-height', `${height}px`);
  };

  if (announcementBar) {
    new ResizeObserver(updateAnnouncementBarHeight).observe(announcementBar);
    mobileViewport.addEventListener('change', updateAnnouncementBarHeight);
    window.addEventListener('load', updateAnnouncementBarHeight, { once: true });
    updateAnnouncementBarHeight();
  }

  } catch(e) { console.error(e); }
})();
})();
